import {useMutation} from 'react-query';
import {useAuth} from '../../../context/authContext';

import {signUp} from '../../../services/auth';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';
const UseSignUp = () => {
  const {login} = useAuth();
  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: ISignUpPayload) => {
      return signUp(payload);
    },
    onSuccess: (data, variables) => {
      login({
        is_registered: data?.is_registered,
        message: data?.message,
        token: data?.token,
        profile: {
          farmer_profile: data?.farmer_profile,
          supplier_profile: data?.supplier_profile,
          marrket_profile: data?.market_profile,
        },
      });
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate};
};

export default UseSignUp;
